export enum ProcessType {
  TRIPABROAD = 'tripAbroad',
  TRAVELINPL = 'travelInPL',
  RESIGNATION = 'resignation',
}
